import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=999f1444&scoped=true"
import script from "./DoughnutChart.vue?vue&type=script&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&lang=js"
import style0 from "./DoughnutChart.vue?vue&type=style&index=0&id=999f1444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999f1444",
  null
  
)

export default component.exports